import {
  Body2,
  Button,
  Card,
  CardFooter,
  CardHeader,
  Title2,
} from "@fluentui/react-components";

export const TeamInstallationAlreadyInstalled = ({
  redirect: { url, openInNewTab = false },
}: {
  redirect: {
    url: string;
    openInNewTab: boolean;
  };
}) => (
  <Card size="large" className="w-full max-w-lg">
    <CardHeader header={<Title2>BeZoned is already installed</Title2>} />
    <Body2>
      BeZoned application is already installed in this team. Please continue to
      the Lobby and enter the office from there.
    </Body2>
    <CardFooter className="flex justify-end gap-2">
      <Button
        appearance="primary"
        as="a"
        href={url}
        rel={openInNewTab ? "noopener noreferrer" : undefined}
        target={openInNewTab ? "_blank" : undefined}
      >
        Open Lobby
      </Button>
    </CardFooter>
  </Card>
);
